import React from 'react';
import { Container, Row, Col, Card, Carousel } from 'react-bootstrap';
import '../styles/Products.css';
import product1 from '../assets/product1.jpg';
import product2 from '../assets/product2.jpg';
import product3 from '../assets/product3.jpg';
import product4 from '../assets/product4.JPG';
import product51 from '../assets/product5-1.png';
import product52 from '../assets/product5-2.png';
import product53 from '../assets/product5-3.png';
import product54 from '../assets/product5-4.png';
import product6 from '../assets/product6.png';
import product7 from '../assets/product7.png';
import product71 from '../assets/product7-1.jpg';
import product8 from '../assets/product8.png';
import product9 from '../assets/product9.png';
import product10 from '../assets/product10.png';
import product11 from '../assets/product11.png';
import product12 from '../assets/product12.png';
import product13 from '../assets/product13.png';
import product14 from '../assets/product14.png';
import product15 from '../assets/product15.png';
import product16 from '../assets/product16.jpg';


const products = [
  {
    title: 'Oilfield Components',
    image: product1,
    description: 'High-performance components for harsh oilfield environments.'
  },
  {
    title: 'EDM Wire-cut Components',
    image: product2,
    description: 'Component manufactured for automotive component testing'
  },
  {
    title: 'Precision Machined Components',
    images: [
      product51,
      product52,
      product53,
      product54
    ],
    description: 'Precision machined components application in Oil & Gas industry.'
  },
  {
    title: 'Aluminium Automation Components',
    image: product6,
    description: 'Precision-engineered die sets used in automotive production.'
  },
  {
    title: 'Aluminium Housings',
    image: product3,
    description: 'Tough, tested housings for defense equipment.'
  },
  {
    title: 'Gear Rack',
    image: product4,
    description: 'Rack gears for high-precision applications. Used in Oil & Gas industry.'
  },
  {
    title: 'Threaded Components',
    images: [
      product7,
      product71
    ],
    description: 'Precision threaded components for various applications.'
  },
  {
    title: 'Automobile Fixture',
    image: product8,
    description: 'Fixtures for automotive assembly and testing.'
  },
  {
    title: 'Heavy Duty Machining',
    image: product9,
    description: 'Heavy duty Connector for Oil Rigs'
  },
  {
    title: 'Mobility Component',
    image: product10,
    description: 'Heavy duty Connector used in Oil Rigs'
  },
  {
    title: 'Mobility Component',
    image: product11,
    description: 'Heavy duty Connector used in Oil Rigs'
  },
  {
    title: 'Cavity Insert',
    image: product12,
    description: 'Heavy duty Connector used in Oil Rigs'
  },
  {
    title: 'Copper EDM Electrode',
    image: product13,
    description: 'Heavy duty Connector used in Oil Rigs'
  },
  {
    title: 'Gas Pipeline Welded Stands',
    image: product14,
    description: 'Heavy duty Connector used in Oil Rigs'
  },
  {
    title: 'Precision Welded Assembly',
    image: product15,
    description: 'Heavy duty Connector used in Oil Rigs'
  },
  {
    title: 'Core & Cavity Mold',
    image: product16,
    description: 'Heavy duty Connector used in Oil Rigs'
  }
];

export default function Products() {
  return (
    <Container className="my-5">
      <h2 className="text-center mb-4">Product Gallery</h2>
      <Row>
        {products.map((product, idx) => (
          <Col md={6} lg={3} key={idx} className="mb-4">
            <Card className="h-100 product-card">
              <div className="image-wrapper">
                {product.images ? (
                  <Carousel interval={2000} indicators={false} pause={false}>
                    {product.images.map((imgSrc, i) => (
                      <Carousel.Item key={i}>
                        <img className="d-block w-100" src={imgSrc} alt={`Angle ${i + 1}`} />
                      </Carousel.Item>
                    ))}
                  </Carousel>
                ) : (
                  <Card.Img variant="top" src={product.image} alt={product.title} />
                )}
                <div className="hover-overlay">
                  <span className="hover-text">{product.title}</span>
                </div>
              </div>
              {/* <Card.Body>
                <Card.Title>{product.title}</Card.Title>
                <Card.Text>{product.description}</Card.Text>
              </Card.Body> */}
            </Card>

          </Col>
        ))}
      </Row>

      <section className="contact-section py-5 bg-custom-dark text-custom-light">
        <Container>
          <Row>
            <Col md={12} className="text-center">
              <h2>Get in Touch</h2>
              <p>Ready to discuss your project? Contact us today!</p>
              <a href="/contact" className="btn btn-primary">Contact Us</a>
            </Col>
          </Row>
        </Container>
      </section>

    </Container>
  );
}
